import $ from 'jquery';


export default () => {
    console.log('older age');

    var user_lang = $('body').attr('data-lang');
    var expire_date = 60000 * 60 * 24 * 365;

    var label_older_age = 'older_age_' + user_lang;
    var cookie_older_age = getWithExpiry(label_older_age);
    console.log(typeof cookie_older_age);

    if ($('#layerOlderAge').length > 0) {
        if (cookie_older_age === 0 || cookie_older_age === null || cookie_older_age === undefined || cookie_older_age === false || cookie_older_age === "") {
            $('#layerOlderAge').addClass('show');
            $('body').addClass('layerOlderAge_open');
        }
        else {
            hideLayer();
        }
        if (!cookie_older_age && user_lang !== 'it') {
            console.log('sono estero');

            $('#btn-older-age-si').on('click', function () {
                setWithExpiry(label_older_age, 1, expire_date);
                hideLayer();
            });
            $('#btn-older-age-no').on('click', function () {
                console.log('older age no');
                $('.older-age-btn').hide();
                $('.older-age-messaggio').show();
            });
        }
        else if (!cookie_older_age && user_lang === 'it') {
            console.log('non sono estero');
            $('#btn-older-age-prosegui').on('click', function () {
                setWithExpiry(label_older_age, 1, expire_date);
                hideLayer();
            });
        }
    } else {
        hideLayer();
    }

    function setWithExpiry(key, value, ttl) {
        const now = new Date()

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl
        }
        localStorage.setItem(key, JSON.stringify(item))
    }

    function getWithExpiry(key) {
        const itemStr = localStorage.getItem(key)

        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }

        const item = JSON.parse(itemStr)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        return item.value
    }

    function hideLayer() {
        $('#layerOlderAge').removeClass('show');
        $('body').removeClass('layerOlderAge_open');
        $(document).trigger("older_age_complete");
    }


};



// WEBPACK FOOTER //
// ./scripts/libs/layer-older-age.js